import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import utilService from '../../services/util.service';

export const addReference = createAsyncThunk('videoSlice/addReference', async (params, thunkAPI) => {
  try {
    const data = await utilService.addReferenceAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getReference = createAsyncThunk('videoSlice/getReference', async (params, thunkAPI) => {
  try {
    const data = await utilService.getReferenceAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  refrenceList: []
};

const videoSlice = createSlice({
  name: 'videoSlice',
  initialState,
  extraReducers: {
    [getReference.fulfilled]: (state, action) => {
      state.refrenceList = action.payload.data;
    }
  }
});

const { reducer } = videoSlice;
export default reducer;
